import { IKnmErknmFormInspector } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormInspector';
import { IKnmErknmFormExpert } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormExpert';
import { IKnmErknmFormActExpert } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormActExpert';
import { IDecisionFormRef } from 'DecisionPackage/MainModule/interfaces/IDecisionFormRef';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';

import { KnmActInspectors } from './KnmActInspectors';
import { KnmActExperts } from './KnmActExperts';
import { KnmActWitnesses } from './KnmActWitnesses';

interface IErknmActsItemProps {
  id: string;
  index?: number;
  inspectorsErknm: IKnmErknmFormInspector[] | undefined;
  name: string;
  isDisabledField: boolean;
  expertsErknm: IKnmErknmFormExpert[] | undefined;
  involvedExperts?: IKnmErknmFormActExpert[];
  isDecision?: boolean;
  isPm?: boolean;
  isKnm?: boolean;
  formRef: IKnmFormRef | IDecisionFormRef | undefined;
}

export const KnmActParticipants = ({
  id,
  index,
  inspectorsErknm,
  name,
  isDisabledField,
  expertsErknm,
  involvedExperts,
  isDecision,
  isPm,
  isKnm,
  formRef,
}: IErknmActsItemProps) => {
  return (
    <>
      <KnmActInspectors
        id={id}
        index={index}
        inspectorsErknm={inspectorsErknm}
        isDisabledField={isDisabledField}
        name={name}
        isDecision={isDecision}
        isPm={isPm}
        isKnm={isKnm}
        formRef={formRef}
      />
      {!isDecision && (
        <KnmActExperts
          id={id}
          index={index}
          isDisabledField={isDisabledField}
          name={name}
          expertsErknm={expertsErknm}
          involvedExperts={involvedExperts}
          formRef={formRef}
        />
      )}
      <KnmActWitnesses id={id} index={index} isDisabledField={isDisabledField} name={name} formRef={formRef} />
    </>
  );
};
